import { CompanyEffects } from './company.effects';
import { ContactEffects } from './contact.effects';
import { CurrentUserEffects } from './current-user.effects';
import { FeaturesEffects } from './features.effects';
import { CurrentCustomerEffects } from './current-customer.effects';
import { NewsEffects } from './news.effects';
import { EmployeeEffects } from './employee.effects';
import { UserGroupEffects } from './user-group.effects';
import { InviteEffects } from './invite.effects';
import { VehicleEffects } from './vehicle.effects';
import { VehicleGroupEffects } from './vehicle-group.effects';
import { ScheduledReportsEffects } from './scheduled-reports.effects';
import { OperatorSchedulesEffects } from './operator-schedules.effects';
import { VehicleScheduleEffects } from './vehicle-schedule.effects';
import { DvrSettingsEffects } from './dvr-settings.effects';
import { CameraEffects } from '../../vehicles/store/effects/camera.effects';
import { GroupPermissionsEffects } from './group-permissions.effects';
import { MapSettingsEffects } from './map-settings.effects';

import * as fromLocationsEffects from '../../locations/store/effects';
import { HardwareEffects } from '@fc-store/effects/hardware.effects';
import { HarnessEffects } from '@fc-store/effects/harness.effects';

export const effects = [
  CompanyEffects,
  ContactEffects,
  CurrentCustomerEffects,
  CurrentUserEffects,
  FeaturesEffects,
  NewsEffects,
  EmployeeEffects,
  UserGroupEffects,
  InviteEffects,
  VehicleEffects,
  VehicleGroupEffects,
  ScheduledReportsEffects,
  OperatorSchedulesEffects,
  VehicleScheduleEffects,
  DvrSettingsEffects,
  CameraEffects,
  GroupPermissionsEffects,
  MapSettingsEffects,
  HardwareEffects,
  HarnessEffects,
  ...fromLocationsEffects.effects,
];

export * from './company.effects';
export * from './contact.effects';
export * from './current-user.effects';
export * from './features.effects';
export * from './current-customer.effects';
export * from './vehicle.effects';
export * from './vehicle-group.effects';
export * from './scheduled-reports.effects';
export * from './operator-schedules.effects';
export * from './map-settings.effects';
export * from '../../locations/store/effects';
